import Config from '../Config';
import Services from './services';

const ModifierModel = {
    getProviderModifiersById: (id, locale = Config.DEFAULT_LANG_CODE) => {
        return Services.getApi(Config.getBasePath() + `/providers/${id}/modifiers?locale=${locale}`);
    },
    createProviderModifiers: (modifiers) => {
        return Services.postApi(Config.getBasePath() + '/provider-modifiers', modifiers);
    },
    getProviderModifierById: (id, locale = Config.DEFAULT_LANG_CODE) => {
        return Services.getApi(Config.getBasePath() + `/provider-modifiers/${id}?locale=${locale}`);
    },
    updateProviderModifiers: (modifier, id) => {
        return Services.putApi(Config.getBasePath() + `/provider-modifiers/${id}`, modifier);
    },

    deleteProviderModifierById: (modifierId) => {
        return Services.deleteApi(Config.getBasePath() + `/provider-modifiers/${modifierId}`);
    },
    remote_getAll: () => {
        return Services.getApi(Config.getBasePath() + '/modifiers');
    },
    copyModifier: (modifier) => {
        return Services.postApi(Config.getBasePath() + '/modifiers', modifier);
    },
    deleteModifier: (id) => {
        return Services.deleteApi(Config.getBasePath() + `/modifiers/${id}`);
    },
    getModifierById: (id) => {
        return Services.getApi(Config.getBasePath() + `/modifiers/${id}`);
    },
    createModifier: (modifier) => {
        return Services.postApi(Config.getBasePath() + '/modifiers', modifier);
    },
    updateModifier: (id, modifier) => {
        return Services.putApi(Config.getBasePath() + `/modifiers/${id}`, modifier);
    },
};

export default ModifierModel;
